// extracted by mini-css-extract-plugin
module.exports = {"accessories":"Accessories_accessories__whM1q","item":"Accessories_item__pFimL","submitBtn":"Accessories_submitBtn__3SMoo"};